import React, { useEffect } from "react"
import { useDispatch } from "react-redux"

import TodaysRunsTable from "./components/TodaysRunsTable"
import QuickbooksFilesTable from "./components/QuickbooksFilesTable"
import { fetchTodaysRuns, fetchQuickbooksFiles } from "./clientBatchingSlice"

export default function TodaysRunsPage() {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchTodaysRuns())
        dispatch(fetchQuickbooksFiles())
    }, [dispatch])

    return (
        <>
            <TodaysRunsTable />
            <QuickbooksFilesTable />
        </>
    )
}
